var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('vmm-form',{key:_vm.form_key,ref:"form",attrs:{"name":_vm.model,"options":{},"record":_vm.record,"submit":true,"inline":false},on:{"saved":_vm.saved}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }